import Ajax from '@utils/ajax';

export default {
  create(url, name, mime_type, size, options = {}) {
    return Ajax.post({
      url: `/embedded_uploads`,
      data: { url: url, name: name, size: size, mime_type: mime_type },
      ...options,
    });
  },
};
